<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span id="clients">
        <el-row :gutter="20">
            <el-col :xs="24" >
                <h1 style="font-size: 35px !important" class="chevere-title">Clientes satisfechos</h1>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <Carousel   
                    :per-page-custom=[[250,1],[350,1],[480,1],[720,2],[1024,2]]
                    :mouse-drag="true"
                    :autoplay="false"
                    :loop="true"
                    :paginationEnabled="false">
                <Slide>
                    <el-row :gutter="20">
                        <img class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/new_hotel.png" alt="New Hotel" title="New Hotel"><br><br>
                        <span class="job-description"> NewHotel Software Perú</span><br>
                        <span class="job-description"> Integración WebService Reniec-Sunat.</span>
                    </el-row>
                </Slide> 
                <!-- <Slide>
                    <el-row :gutter="20">
                        <img style="border-radius=25px;" class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/sap.png" alt="Sap Perú" title="Sap Perú"><br><br>
                        <span class="job-description"> SAP Perú</span><br>
                        <span class="job-description"> Integración de consulta Ruc y tipo de cambio.</span>
                        <p class="chevere-text-k">"Atención buena y rápida, siempre atento a cualquier eventualidad y a resolver los problemas."</p>
                    </el-row>
                </Slide>                -->
                <Slide>
                    <el-row :gutter="20">
                        <img style="border-radius=25px;" class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/tambo.png" alt="Hoteles El tambo" title="Hoteles el Tambo"><br><br>
                        <span class="job-description"> Hoteles el Tambo</span><br>
                        <span class="job-description"> Desarrollo Página con página con módulo de administración.</span>
                        <!--<p class="chevere-text-k">"Atención buena y rápida, siempre atento a cualquier eventualidad y a resolver los problemas."</p>-->
                    </el-row>
                </Slide>
                <Slide>
                    <el-row :gutter="20">
                        <img class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/valprasa.png" alt="Javier Tena" title="Javier Tena"><br><br>
                        <span class="job-description"> Valprasa</span><br>
                        <span class="job-description"> Desarrollo e implementacion de sistema de facturación a la medida.</span>
                        <p class="chevere-text-k">"Personas amables de buen criterio, eficacez en el desarrollo de sistema de facturación electrónica y proactivos."</p>
                    </el-row>
                </Slide>
                
                <Slide>
                    <el-row :gutter="20">
                        <img style="border-radius=25px;" class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/aquasec.png" alt="Aquasec" title="Aquasec"><br><br>
                        <span class="job-description"> Aquasec</span><br>
                        <span class="job-description"> Desarrollo página con sistema de pedidos online.</span>
                        <!--<p class="chevere-text-k">"Atención buena y rápida, siempre atento a cualquier eventualidad y a resolver los problemas."</p>-->
                    </el-row>
                </Slide>  
                <Slide>
                    <el-row :gutter="20">
                        <img style="border-radius=25px;" class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/datatronica.png" alt="Datatrónica Perú" title="Datatrónica Perú"><br><br>
                        <span class="job-description"> Datatrónica Perú</span><br>
                        <span class="job-description"> Desarrollo página con sistema de gestión.</span>
                        <p class="chevere-text-k">"Atención buena y rápida, siempre atento a cualquier eventualidad y a resolver los problemas."</p>
                    </el-row>
                </Slide>
                <Slide>
                    <el-row :gutter="20">
                        <img style="border-radius=25px;" class="chevere-carousel-clientes" src="@/../public/assets/images/clientes/effort.png" alt="Effort ingenieros" title="Effort ingenieros"><br><br>
                        <span class="job-description"> Effort ingenieros</span><br>
                        <span class="job-description"> Desarrollo Página web responsive.</span>
                        <!--<p class="chevere-text-k">"Atención buena y rápida, siempre atento a cualquier eventualidad y a resolver los problemas."</p>-->
                    </el-row>
                </Slide>  
                     
            </Carousel>                
        </el-row>
    </span>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "clientes",
    components: {
        Carousel,
        Slide
    }
}
</script>

<style scoped>
    .job-description{
        display: inline;
        /*text-decoration: underline;*/
        font-weight: bold;
    }
</style>





// WEBPACK FOOTER //
// src/sections/Clientes.vue